import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils';

const badgeVariants = cva(
  'clr-status-badge inline-flex items-center justify-center',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'clr-status-badge--outreach',
        outline: 'text-foreground border-[#e0e4e0] bg-transparent',
        success: 'clr-status-badge--accepted',
        danger: 'clr-status-badge--declined',
        warning: 'clr-status-badge--pending',
        muted: 'clr-status-badge--muted',
        outreach: 'clr-status-badge--outreach',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
